import React from "react";
import { Trans, translate } from "react-i18next";
import compose from "ramda/src/compose";
import { bool, func } from "prop-types";
import { Modal, Button } from "shared/components";
import styles from "./styles.css";
import iconRepair from "../../../../assets/svg/icone-erroGeral-direcionar-atendimento.svg";

const ModalGeneralError = ({ t, isCurrentStep, onReset, messageKey }) => {
  return (
    <Modal isOpen={isCurrentStep} onClose={onReset}>
      <div className={styles.root}>
        <img src={iconRepair} alt="" />
        <p>
          <Trans i18nKey={messageKey}>
            <br />
          </Trans>
        </p>
        <div className={styles.actions}>
          <Button onClick={onReset} relevance="normal" callToAction>
            {t("MSG_0111")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

ModalGeneralError.propTypes = {
  isOpen: bool,
  onClose: func.isRequired,
};

ModalGeneralError.defaultProps = {
  isOpen: false,
};

const enhance = compose(translate());

export default enhance(ModalGeneralError);



// WEBPACK FOOTER //
// ./src/components/RepairWizard/components/ModalGeneralError/index.js